import React, {Component, ReactNode} from 'react';

interface State {
    hasError: boolean;
    error: Error | string;
    errorInfo: React.ErrorInfo;
}

interface Props {
    children: ReactNode;
    errorInformation: any;
}

export class ErrorBoundary extends Component<Props, State> {
    static defaultProps = {
        errorInformation: (props: State) => (
            <div style={{textAlign: 'center'}}>
                <h2>Something went wrong</h2>
            </div>
        )
    };

    state = {
        hasError: false,
        error: '',
        errorInfo: {
            componentStack: ''
        }
    };

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
        this.setState({
            hasError: true,
            error,
            errorInfo
        });
    }

    render() {
        const {hasError, error, errorInfo} = this.state;

        if (hasError) {
            return this.props.errorInformation({error, errorInfo});
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
